
















































import Vue from "vue";
import Component from "vue-class-component";
import { api } from "@/api";
import ArticleCard from "@/components/ArticalCard.vue";
import IncomeStep from "@/components/IncomeStep.vue";

@Component({
  components: { IncomeStep, ArticleCard },
})
export default class Income extends Vue {
  protected lists: any[] = [];

  protected total: number = 0; // 总数
  protected page: number = 1; // 页数
  protected finished: boolean = false;
  protected loading: boolean = false;

  public async mounted() {
    this.onLoad();
  }

  public async onLoad() {
    const resp = await api.getIncomeList({ page: this.page });
    this.loading = false;
    console.log(resp);
    if (!resp.length) {
      this.finished = true;
    } else {
      if (this.page == 1) {
        this.lists.push(...resp);
      } else {
        resp.forEach((val: any, index: any) => {
          let isSameIndex = this.lists.findIndex(
            (cval) => cval.month == val.month
          );
          if (isSameIndex != -1) {
            let sameArray = Object.keys(this.lists[isSameIndex].list);
            console.log(sameArray);
            let newResArray = Object.keys(val.list);
            let isSameSubArray = newResArray.filter((fval) => {
              return sameArray.indexOf(fval) > -1;
            });
            this.lists[isSameIndex].total += val.total;
            if (!isSameSubArray.length) {
              newResArray.forEach((nval) => {
                this.lists[isSameIndex].list[nval] = val.list[nval];
              });
            } else {
              isSameSubArray.forEach((sval) => {
                console.log(
                  this.lists[isSameIndex].list[sval].list.length,
                  val.list[sval].list.length
                );
                // this.lists[isSameIndex].list[sval].list = [
                //   ...this.lists[isSameIndex].list[sval].list,
                //   ...val.list[sval].list,
                // ];
                this.lists[isSameIndex].list[sval].list.push(
                  ...val.list[sval].list
                );
                console.log(newResArray.indexOf(sval));
                this.lists[isSameIndex].list[sval].total +=
                  val.list[sval].total;
                newResArray.splice(newResArray.indexOf(sval), 1);
              });
              console.log(newResArray);
              newResArray.forEach((nval) => {
                this.lists[isSameIndex].list[nval] = val.list[nval];
              });
            }
          } else {
            this.lists.push(val);
          }
        });
      }
    }
    this.total = resp.last_page;
  }

  public onRefresh(done: any) {
    console.log("onRefresh");
    this.page = 1;
    this.lists = [];
    this.onLoad();
  }
  public loadMore(done: any) {
    console.log("loadMore");
    this.page++;
    this.onLoad();
  }

  public getTotal(total: number) {
    return "收入： ¥" + total / 100;
  }

  public getMonth(month: string) {
    const date = new Date();
    const m = date.getMonth() + 1;
    if (parseInt(month) === m) {
      return "本月";
    }

    return month + "月";
  }
  public openQQ() {
    window.open("http://wpa.qq.com/msgrd?v=3&uin=3509065783&site=qq&menu=yes");
  }
  public linkToArticle() {
    this.$router.push("/article/list");
  }
}
